import ServerSettings from "../../../gd/settings/server-settings/server-settings";

const fieldsConfig = {

    //boardViewBg
    'bg': {
        type            : 'option',
        defaultValue    : 'gray',
        options         : ['gray','white']
    },


}

export default class UserSettingsViewsBoard extends ServerSettings {

    public bg: any

    constructor(config: any) {

        super(config, fieldsConfig);

        // bgInverted
        this.bg                 = this.initValue('bg')
    }


    toJson() {
        const result = {};

        this.valueToJson(result, 'bg')

        return result;
    }
}
